import Avatar from '@mui/material/Avatar'
import { amber, blue } from '@mui/material/colors'
import { useTheme } from '@mui/material/styles'
import React from 'react'

import { ReactComponent as CalendarDayIcon } from 'assets/CalendarDay.svg'
import { ReactComponent as CalendarRecurringIcon } from 'assets/CalendarRecurring.svg'
import { RECURRENCE } from 'settings/constants/service'

import type { AvatarProps } from '@mui/material/Avatar'

const { RECURRING } = RECURRENCE

type Props = AvatarProps & {
  serviceType?: string | null
  isDraft?: boolean
}

const ServiceTypeAvatar: React.FC<Props> = ({ serviceType = '', isDraft = false, sx, ...rest }) => {
  const isRecurringService = (serviceType ?? '').toUpperCase() === RECURRING.toUpperCase()
  const theme = useTheme()
  const getBgColor = () => {
    if (isDraft) return theme.palette.action.disabled
    return isRecurringService ? blue[500] : amber[500]
  }

  return (
    <Avatar sx={[{ width: 24, height: 24, bgcolor: getBgColor() }, ...(Array.isArray(sx) ? sx : [sx])]} {...rest}>
      {isRecurringService ? <CalendarRecurringIcon width={20} height={20} /> : <CalendarDayIcon width={20} height={20} />}
    </Avatar>
  )
}

export default ServiceTypeAvatar
